(function ($) {
  Drupal.behaviors.imageWithTextV1 = {
    attach: function (context, settings) {
      var self = this;

      $('.image-with-text-v1').each(function () {
        var thisFormatter = $(this);
      });
    }
  };
})(jQuery);
